import {AnimatedText} from '#component/base';
import {Transition} from '#component/util';
import {sprinkles} from '#style/sprinkles';

import {StepProps} from '../../StorySteps.types';
import {animTextLeft} from '../StorySteps.css';

export const Step1 = ({afterEnter, show}: StepProps) => (
  <Transition className={sprinkles({position: 'absolute', inset: 0})} show={show}>
    <AnimatedText
      afterEnter={afterEnter}
      className={animTextLeft}
      color="deepBurgundy"
      variant="heading3">
      Using robust epigenetic technology, we have analyzed your DNA and measured your most important
      CpG sites to produce an accurate snapshot of how your body is aging on a cellular level.
    </AnimatedText>
  </Transition>
);
